import * as React from "react";
import type { SVGProps } from "react";

const ConnectorMcs = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M12 20.0131C12.9665 20.0131 13.75 19.2296 13.75 18.2631C13.75 17.2966 12.9665 16.5131 12 16.5131C11.0335 16.5131 10.25 17.2966 10.25 18.2631C10.25 19.2296 11.0335 20.0131 12 20.0131Z"
      fill="currentColor"
    />
    <path
      d="M8.50488 13C9.28595 13.0002 9.91892 13.6127 9.91895 14.3682C9.91895 15.1236 9.28597 15.7362 8.50488 15.7363C7.72366 15.7363 7.08984 15.1237 7.08984 14.3682C7.08987 13.6126 7.72367 13 8.50488 13Z"
      fill="currentColor"
    />
    <path
      d="M15.5039 13C16.2851 13 16.9189 13.6126 16.9189 14.3682C16.9189 15.1237 16.2851 15.7363 15.5039 15.7363C14.7229 15.7361 14.0898 15.1235 14.0898 14.3682C14.0899 13.6128 14.7229 13.0002 15.5039 13Z"
      fill="currentColor"
    />
    <path
      vectorEffect="non-scaling-stroke"
      d="M15.5702 20.472C13.896 23.0643 10.1041 23.0644 8.42985 20.472L2.4773 11.2552C-0.101148 7.26272 2.76485 2 7.51754 2L16.4825 2C21.2352 2 24.1012 7.26271 21.5227 11.2552L15.5702 20.472Z"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="bevel"
    />
    <path
      d="M4.5 7.75C4.5 9.26878 5.73122 10.5 7.25 10.5C8.76878 10.5 10 9.26878 10 7.75C10 6.23122 8.76878 5 7.25 5C5.73122 5 4.5 6.23122 4.5 7.75Z"
      fill="currentColor"
    />
    <path
      d="M14 7.75C14 9.26878 15.2312 10.5 16.75 10.5C18.2688 10.5 19.5 9.26878 19.5 7.75C19.5 6.23122 18.2688 5 16.75 5C15.2312 5 14 6.23122 14 7.75Z"
      fill="currentColor"
    />
    <path
      d="M13 10C13.8284 10 14.5 10.6716 14.5 11.5C14.5 12.3284 13.8284 13 13 13H11C10.1716 13 9.5 12.3284 9.5 11.5C9.5 10.6716 10.1716 10 11 10H13Z"
      fill="currentColor"
    />
  </svg>
));
ConnectorMcs.displayName = "ConnectorMcs";

export default ConnectorMcs;
